module.exports = __webpack_public_path__ + "static/img/MARCA 1.9951216.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/MARCA 1.png
// module id = 674
// module chunks = 0